export default function GoldDivider({ label, className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-5 ${className}`}>
      <span className="rule-thin" style={{ width: 48 }} />
      {label && (
        <span className="font-marcellus uppercase tracking-[0.4em] text-[0.68rem] text-[var(--gold-deep)]">
          {label}
        </span>
      )}
      {!label && (
        <span aria-hidden="true" className="text-base text-[var(--gold)]">
          ✦
        </span>
      )}
      <span className="rule-thin" style={{ width: 48 }} />
    </div>
  );
}
